import { makeStyles } from "@material-ui/core/styles";
import myTheme from "../../themes/palette";
const useStyles = makeStyles((theme) => {
  return {
    mainAboutusContainer: {
      paddingLeft: theme.spacing(myTheme.padding.left + 3.4),
      paddingRight: theme.spacing(myTheme.padding.right + 3.4),
      paddingBottom: 50,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
    },
    bCrumbLink: {
      "text-decoration": "none",
      "&:hover": {
        color: "black",
        "text-decoration": "none",
      },
    },
    cartTitleBox:{
        //border: '0.1px solid #e9e9e9',
        padding: 15,
        backgroundColor:'#fff',
        borderRadius:3,
        borderLeft: '3px solid '+myTheme.palette.primary.main,
        justifyContent:'space-between',
        borderRadius:0,
        display:'flex',
        alignItems:'center',
        width:'100%',
        [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
          flexDirection: "column",
          alignItems: "center",
          paddingRight: 0,
          paddingLeft: 0,
        },
    },
    checkoutTitleBox:{
      display:'flex', 
      alignItems:'center',
      borderLeft: '3px solid '+myTheme.palette.primary.main,
      padding: 20,
      backgroundColor:"#fff" 
    },
    CartItemBox:{
        backgroundColor:"#fff",
        marginTop:15,
        minWidth:'100%'
    },
    storeNameBox:{
        padding:15,
        display:'flex',
        flexDirection:'column',
        borderBottom:'0.2px solid #e9e9e9'
    },
    productDetailsBox:{
        padding:15,
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center',
        [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
          flexDirection: "column",
          alignItems:'flex-start',
        },
    },
    totalItemsText:{
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        marginTop:8
      },
    },
    itemImageBox:{
        width:100,
        height:100,
        objectFit:'contain',
        marginRight:20
    },
    priceTextBoxInCartItem:{
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        display:'flex',
        justifyContent:'space-between'
      },
    },
    priceText:{
        color:myTheme.palette.primary.main,
        fontWeight:'bold'
    },
    priceSection:{
        display:'flex',
        flexDirection:'column',
        [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
          marginTop:10,
          width:'100%',
        },
    },
    inputVoucher:{
      width: 290,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
      
        width:'100%'
      }
    },
    productTitleText:{
      maxWidth: 300 ,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
      maxWidth:170
      }
    },
    checkoutBoxMianDiv:{
      margin: 45,
      marginTop: 0,
      marginRight: 0,
      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        margin:0,
        marginTop:15,
        width:'100%'
      },
    },
    mainCheckoutBox:{
      backgroundColor:'#fff',
      padding:22,
      borderTop:'0.06px solid #e9e9e9'
    },
    newsletterBtn:{
      textTransform: "none",
      backgroundColor: '#e9e9e9',
      borderTopRightRadius: theme.shape.borderRadius,
      borderBottomRightRadius: theme.shape.borderRadius,
      paddingLeft: 30,
      paddingRight: 30,
      borderColor: myTheme.palette.secondary.light,
      padding:0
    },
    goToStoreBtn:{
      backgroundColor: myTheme.palette.primary.main,
      color: myTheme.palette.primary.contrastText,
      "&:hover": {
        backgroundColor:myTheme.palette.primary.dark,
        color: myTheme.palette.primary.contrastText,
      },
      marginTop:20,
      width:'100%',
      padding:15
    },
    
  };
});

export default useStyles;
